(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["antbelt-campaign-archive"] && !Shopify.designMode) return;
  try {
    
(() => {
  const slugify = (value) => value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');

  document.querySelectorAll('.ks-story-exact').forEach((section) => {
    if (section.dataset.tocReady === 'true') return;
    section.dataset.tocReady = 'true';

    const toc = section.querySelector('.ks-story-exact__toc');
    const nav = section.querySelector('.ks-story-exact__toc-links');
    const headings = [...section.querySelectorAll('.ks-story-exact__content h3')];
    const links = headings.map((heading, index) => {
      heading.id = `story-${slugify(heading.textContent) || 'section'}-${index + 1}`;
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      nav.appendChild(link);
      return link;
    });

    let ticking = false;
    const setActiveChapter = () => {
      const currentIndex = headings.reduce((activeIndex, heading, index) => (
        heading.getBoundingClientRect().top <= 160 ? index : activeIndex
      ), 0);
      links.forEach((link) => link.removeAttribute('aria-current'));
      const active = links[currentIndex];
      if (active) {
        active.setAttribute('aria-current', 'true');
        const navRect = toc.getBoundingClientRect();
        const activeRect = active.getBoundingClientRect();
        if (activeRect.top < navRect.top) toc.scrollTop -= navRect.top - activeRect.top + 8;
        if (activeRect.bottom > navRect.bottom) toc.scrollTop += activeRect.bottom - navRect.bottom + 8;
      }
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(setActiveChapter);
    }, { passive: true });
    setActiveChapter();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["antbelt-g1-development-update"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.g1-report__video-play');
    if (!button) return;

    var card = button.closest('.g1-report__video');
    var stage = card && card.querySelector('.g1-report__video-stage');
    var videoId = card && card.getAttribute('data-youtube-id');
    if (!stage || !videoId) return;

    var activeCard = document.querySelector('.g1-report__video.is-playing');
    if (activeCard && activeCard !== card) {
      var activeFrame = activeCard.querySelector('iframe');
      var activeButton = activeCard.querySelector('.g1-report__video-play');
      if (activeFrame) activeFrame.remove();
      if (activeButton) activeButton.hidden = false;
      activeCard.classList.remove('is-playing');
    }

    if (card.classList.contains('is-playing')) return;

    var iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(videoId) + '?autoplay=1&rel=0&modestbranding=1';
    iframe.title = button.getAttribute('aria-label') || 'AntBelt G1 development video';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    button.hidden = true;
    stage.appendChild(iframe);
    card.classList.add('is-playing');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["antbelt-g1-pledge-flow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-ab-pledge]');
    if (!root || root.dataset.ready === 'shopify-checkout-v4') return;
    root.dataset.ready = 'shopify-checkout-v4';

    const panels = [...root.querySelectorAll('[data-step-panel]')];
    const stepButtons = [...root.querySelectorAll('[data-step-button]')];
    const rewardInputs = [...root.querySelectorAll('input[name="reward"]')];
    const addonInputs = [...root.querySelectorAll('[data-addon]')];
    const nextToAddons = root.querySelector('[data-next-step="2"]');
    const acknowledge = root.querySelector('[data-acknowledge]');
    const reserveButton = root.querySelector('[data-reserve]');
    const reservationForm = root.querySelector('#AntBeltReservationForm');
    const checkoutButton = root.querySelector('[data-checkout]');
    const accessoriesOnlyButton = root.querySelector('[data-accessories-only]');
    const accessoriesOnlyNote = root.querySelector('[data-accessories-only-note]');
    const summaryHeading = root.querySelector('[data-summary-heading]');
    const checkoutError = root.querySelector('[data-checkout-error]');
    const pageBack = root.querySelector('[data-page-back]');
    const backerContext = root.querySelector('[data-backer-context]');
    const backerContextTitle = root.querySelector('[data-backer-context-title]');
    const summaryTrustTitle = root.querySelector('[data-summary-trust-title]');
    const summaryTrustCopy = root.querySelector('[data-summary-trust-copy]');
    const moneyFormat = root.dataset.moneyFormat || '';
    const currency = root.dataset.currency || 'USD';
    const params = new URLSearchParams(window.location.search);
    const requestedStep = params.get('step');
    const requestedSequence = /^\d{1,6}$/.test(params.get('ks_sequence') || '') ? params.get('ks_sequence') : '';
    const requestedRewardQuantityValue = Number(params.get('quantity') || 1);
    const requestedRewardQuantity = Number.isInteger(requestedRewardQuantityValue)
      ? Math.max(1, Math.min(20, requestedRewardQuantityValue))
      : 1;
    let currentRewardQuantity = requestedRewardQuantity;
    let accessoriesOnly = params.get('mode') === 'accessories';
    const flowContext = requestedSequence ? `backer:${requestedSequence}` : 'new';
    const storageKey = `antbeltG1PledgeSelection:${flowContext}`;
    const requestedAddonItemsFromQuery = (params.get('addons') || '')
      .split(',')
      .map((id) => id.trim())
      .filter((id) => /^\d+$/.test(id))
      .map((id) => ({ id, quantity: 1 }));

    pageBack?.addEventListener('click', (event) => {
      if (!document.referrer) return;
      const referrer = new URL(document.referrer);
      if (referrer.origin !== window.location.origin) return;
      event.preventDefault();
      window.history.back();
    });
    const variantIdAliases = {
      '48045745111270': '52562534400132',
      '48045745144038': '52562534432900',
      '48045745176806': '52562534465668',
      '48045745209574': '52562534498436',
      '48045745242342': '52562534596740',
      '48045745537254': '52562534989956',
      '48045745275110': '52562534629508',
      '48045745340646': '52562534727812',
      '48045745438950': '52562534891652',
      '48045745373414': '52562534760580',
      '48045745471718': '52562534924420',
      '48045745504486': '52562534957188',
      '48045745406182': '52562534858884',
      '48045745570022': '52562535022724'
    };
    const canonicalVariantId = (id) => variantIdAliases[String(id)] || String(id || '');
    const flowVariantIds = [...new Set([
      ...Object.keys(variantIdAliases),
      ...Object.values(variantIdAliases)
    ])];
    const backerGroups = JSON.parse(root.querySelector('[data-backer-configurations]')?.textContent || '[]');
    const backerConfiguration = requestedSequence
      ? backerGroups.find((group) => group.sequences.includes(Number(requestedSequence)))
      : null;
    const requestedAddonItems = backerConfiguration
      ? (backerConfiguration.addons || [])
      : requestedAddonItemsFromQuery;

    const cents = (value) => Number(value || 0);
    const formatWithDelimiters = (value, precision = 2, thousands = ',', decimal = '.') => {
      const number = cents(value) / 100;
      if (!Number.isFinite(number)) return '0';
      const parts = number.toFixed(precision).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? `${parts[0]}${decimal}${parts[1]}` : parts[0];
    };
    const formatMoney = (value) => {
      if (!moneyFormat) {
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en', {
            style: 'currency',
            currency
          }).format(cents(value) / 100);
        } catch (_) {
          return `${currency} ${formatWithDelimiters(value)}`;
        }
      }
      return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, (_match, placeholder) => {
        switch (placeholder) {
          case 'amount_no_decimals':
            return formatWithDelimiters(value, 0);
          case 'amount_with_comma_separator':
            return formatWithDelimiters(value, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator':
            return formatWithDelimiters(value, 0, '.', ',');
          case 'amount_with_apostrophe_separator':
            return formatWithDelimiters(value, 2, "'", '.');
          case 'amount_no_decimals_with_space_separator':
            return formatWithDelimiters(value, 0, ' ');
          case 'amount_with_space_separator':
            return formatWithDelimiters(value, 2, ' ', ',');
          case 'amount':
          default:
            return formatWithDelimiters(value);
        }
      });
    };

    const selectedReward = () => rewardInputs.find((input) => input.checked);
    const rewardQuantityInput = (input) => input?.closest('[data-reward-card]')?.querySelector('[data-reward-quantity]');
    const clampRewardQuantity = (value) => {
      const number = Number(value);
      return Number.isFinite(number) ? Math.max(0, Math.min(20, Math.round(number))) : 0;
    };
    const selectedAddons = () => addonInputs.filter((input) => input.checked);
    const addonQuantityInput = (input) => input.closest('.ab-addon')?.querySelector('[data-addon-quantity]');
    const addonQuantity = (input) => {
      const quantity = Number(addonQuantityInput(input)?.value || 0);
      return Number.isInteger(quantity) && quantity > 0 ? Math.min(quantity, 20) : 1;
    };
    const selectionData = () => {
      const reward = selectedReward();
      if (!reward && !accessoriesOnly) return null;
      return {
        kickstarterSequence: requestedSequence,
        accessoriesOnly,
        reward: reward ? {
          id: reward.value,
          title: reward.dataset.title,
          price: cents(reward.dataset.price),
          image: reward.dataset.image,
          quantity: currentRewardQuantity
        } : null,
        addons: selectedAddons().map((input) => ({
          id: input.value,
          title: input.dataset.title,
          price: cents(input.dataset.price),
          image: input.dataset.image,
          quantity: addonQuantity(input),
          kind: input.dataset.kind || 'accessory'
        }))
      };
    };
    const saveSelection = () => {
      const selection = selectionData();
      if (!selection) return;
      try {
        sessionStorage.setItem(storageKey, JSON.stringify(selection));
      } catch (_) {}
    };
    const loadSelection = () => {
      try {
        return JSON.parse(sessionStorage.getItem(storageKey) || 'null');
      } catch (_) {
        return null;
      }
    };

    const renderSummary = () => {
      const selections = [
        selectedReward() ? { input: selectedReward(), quantity: currentRewardQuantity } : null,
        ...selectedAddons().map((input) => ({ input, quantity: addonQuantity(input) }))
      ].filter(Boolean);
      const lines = root.querySelector('[data-summary-lines]');
      const empty = root.querySelector('[data-summary-empty]');
      lines.innerHTML = '';
      empty.hidden = selections.length > 0;
      if (checkoutButton) checkoutButton.disabled = selections.length === 0;
      if (summaryHeading) summaryHeading.textContent = accessoriesOnly ? 'Your accessories' : 'Your order';
      if (accessoriesOnlyNote) accessoriesOnlyNote.hidden = !accessoriesOnly;
      if (!selections.length) {
        if (summaryTrustTitle) summaryTrustTitle.textContent = accessoriesOnly ? 'Select at least one accessory.' : 'Select a machine or choose accessories only.';
        if (summaryTrustCopy) summaryTrustCopy.textContent = accessoriesOnly ? 'Accessories only · Secure checkout' : 'Machine · Add-ons · Secure checkout';
      } else if (accessoriesOnly) {
        if (summaryTrustTitle) summaryTrustTitle.textContent = 'Review your accessories before checkout.';
        if (summaryTrustCopy) summaryTrustCopy.textContent = 'No machine added · Secure Shopify checkout';
      } else if (requestedSequence) {
        if (summaryTrustTitle) summaryTrustTitle.textContent = 'Backer benefits protected.';
        if (summaryTrustCopy) summaryTrustCopy.textContent = 'Launch price · Priority production · Worldwide delivery';
      } else {
        if (summaryTrustTitle) summaryTrustTitle.textContent = 'Review your selection before checkout.';
        if (summaryTrustCopy) summaryTrustCopy.textContent = 'Launch price · Worldwide delivery';
      }
      let total = 0;
      let savings = 0;
      selections.forEach(({ input, quantity }) => {
        const itemPrice = cents(input.dataset.price);
        const comparePrice = cents(input.dataset.comparePrice);
        total += itemPrice * quantity;
        if (comparePrice > itemPrice) savings += (comparePrice - itemPrice) * quantity;
        const line = document.createElement('div');
        line.className = 'ab-summary__line';
        const quantityLabel = quantity > 1 ? ` × ${quantity}` : '';
        line.innerHTML = `<img src="${input.dataset.image}" alt=""><span>${input.dataset.title}${quantityLabel}</span><b>${formatMoney(cents(input.dataset.price) * quantity)}</b>`;
        lines.appendChild(line);
      });
      root.querySelector('[data-summary-total]').textContent = formatMoney(total);
      const savingsRow = root.querySelector('[data-summary-savings]');
      const savingsAmount = root.querySelector('[data-summary-savings-amount]');
      if (savingsRow && savingsAmount) {
        savingsRow.hidden = savings <= 0;
        savingsAmount.textContent = `−${formatMoney(savings)}`;
      }
      const rewardField = root.querySelector('[data-reservation-reward]');
      const rewardIdField = root.querySelector('[data-reservation-reward-id]');
      const addonsField = root.querySelector('[data-reservation-addons]');
      const totalField = root.querySelector('[data-reservation-total]');
      const sequenceField = root.querySelector('[data-reservation-sequence]');
      if (rewardField) rewardField.value = selectedReward()?.dataset.title || '';
      if (rewardIdField) rewardIdField.value = selectedReward()?.value || '';
      if (addonsField) addonsField.value = selectedAddons()
        .map((input) => `${input.dataset.title} × ${addonQuantity(input)}`)
        .join(', ') || 'None';
      if (totalField) totalField.value = formatMoney(total);
      if (sequenceField) sequenceField.value = requestedSequence;
      saveSelection();
    };

    const showStep = (step) => {
      panels.forEach((panel) => {
        const isActive = panel.dataset.stepPanel === String(step);
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });
      stepButtons.forEach((button) => {
        const isActive = button.dataset.stepButton === String(step);
        button.classList.toggle('is-active', isActive);
        if (isActive) button.setAttribute('aria-current', 'step');
        else button.removeAttribute('aria-current');
      });
      const activePanel = panels.find((panel) => panel.dataset.stepPanel === String(step));
      requestAnimationFrame(() => {
        activePanel?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        activePanel?.querySelector('h2')?.focus({ preventScroll: true });
      });
    };

    rewardInputs.forEach((input) => {
      const card = input.closest('[data-reward-card]');
      const quantityInput = rewardQuantityInput(input);
      const minusButton = card?.querySelector('[data-reward-minus]');
      const plusButton = card?.querySelector('[data-reward-plus]');
      const selectCard = () => {
        accessoriesOnly = false;
        if (accessoriesOnlyNote) accessoriesOnlyNote.hidden = true;
        if (!input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const setQuantity = (value) => {
        const quantity = clampRewardQuantity(value);
        if (quantityInput) quantityInput.value = String(quantity);
        if (quantity > 0) {
          selectCard();
          currentRewardQuantity = quantity;
        } else if (input.checked) {
          input.checked = false;
          card?.classList.remove('is-selected');
          nextToAddons.disabled = true;
          stepButtons.slice(1).forEach((button) => button.setAttribute('aria-disabled', 'true'));
        }
        renderSummary();
      };
      input.addEventListener('change', () => {
        const quantity = Math.max(1, clampRewardQuantity(quantityInput?.value));
        if (quantityInput) quantityInput.value = String(quantity);
        rewardInputs.forEach((otherInput) => {
          if (otherInput === input) return;
          const otherQuantityInput = rewardQuantityInput(otherInput);
          if (otherQuantityInput) otherQuantityInput.value = '0';
        });
        currentRewardQuantity = quantity;
        root.querySelectorAll('[data-reward-card]').forEach((card) => card.classList.toggle('is-selected', card.contains(input)));
        nextToAddons.disabled = false;
        stepButtons.slice(1).forEach((button) => button.setAttribute('aria-disabled', 'false'));
        renderSummary();
      });
      quantityInput?.addEventListener('click', (event) => event.stopPropagation());
      quantityInput?.addEventListener('input', () => {
        if (quantityInput.value !== '') setQuantity(quantityInput.value);
      });
      quantityInput?.addEventListener('change', () => setQuantity(quantityInput.value));
      minusButton?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        setQuantity((Number(quantityInput?.value) || 0) - 1);
      });
      plusButton?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        setQuantity((Number(quantityInput?.value) || 0) + 1);
      });
    });
    accessoriesOnlyButton?.addEventListener('click', () => {
      accessoriesOnly = true;
      rewardInputs.forEach((input) => {
        input.checked = false;
        input.closest('[data-reward-card]')?.classList.remove('is-selected');
        const quantityInput = rewardQuantityInput(input);
        if (quantityInput) quantityInput.value = '0';
      });
      currentRewardQuantity = 0;
      nextToAddons.disabled = false;
      stepButtons.slice(1).forEach((button) => button.setAttribute('aria-disabled', 'false'));
      const url = new URL(window.location.href);
      url.searchParams.set('mode', 'accessories');
      url.searchParams.set('step', 'addons');
      url.searchParams.delete('reward');
      url.searchParams.delete('quantity');
      window.history.replaceState({}, '', url);
      renderSummary();
      showStep(2);
    });

    addonInputs.forEach((input) => {
      const addonCard = input.closest('.ab-addon');
      const quantityInput = addonQuantityInput(input);
      const minusButton = addonCard?.querySelector('[data-addon-minus]');
      const plusButton = addonCard?.querySelector('[data-addon-plus]');
      const setQuantity = (nextQuantity) => {
        if (!quantityInput || input.disabled) return;
        const numericQuantity = Number(nextQuantity);
        const quantity = Number.isFinite(numericQuantity)
          ? Math.max(0, Math.min(20, Math.round(numericQuantity)))
          : 0;
        quantityInput.value = String(quantity);
        input.checked = quantity > 0;
        renderSummary();
      };
      input.addEventListener('change', () => {
        setQuantity(input.checked ? Math.max(1, Number(quantityInput?.value) || 1) : 0);
      });
      quantityInput?.addEventListener('input', () => {
        if (quantityInput.value !== '') setQuantity(quantityInput.value);
      });
      quantityInput?.addEventListener('change', () => setQuantity(quantityInput.value));
      quantityInput?.addEventListener('click', (event) => event.stopPropagation());
      minusButton?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        setQuantity((Number(quantityInput?.value) || 0) - 1);
      });
      plusButton?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        setQuantity((Number(quantityInput?.value) || 0) + 1);
      });
    });
    if (acknowledge && reserveButton) {
      acknowledge.addEventListener('change', () => { reserveButton.disabled = !acknowledge.checked; });
    }
    if (reservationForm) reservationForm.addEventListener('submit', saveSelection);

    root.addEventListener('click', (event) => {
      const button = event.target.closest('[data-next-step]');
      if (!button || !root.contains(button)) return;
      const step = Number(button.dataset.nextStep);
      if (step > 1 && !selectedReward() && !accessoriesOnly) return;
      showStep(step);
    });
    stepButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const step = Number(button.dataset.stepButton);
        if (step === 1 || selectedReward() || accessoriesOnly) showStep(step);
      });
    });

    if (requestedSequence && backerContext && backerContextTitle) {
      backerContext.hidden = false;
      backerContextTitle.textContent = `Kickstarter backer #${requestedSequence}`;
      if (summaryTrustTitle) summaryTrustTitle.textContent = 'Backer benefits protected.';
      if (summaryTrustCopy) summaryTrustCopy.textContent = 'Launch price · Priority production · Worldwide delivery';
    }

    const requestedReward = backerConfiguration?.reward || params.get('reward') || '';
    const hasExplicitReward = Boolean(params.get('reward'));
    const savedSelection = loadSelection();
    // Keep a backer's recovered tier/add-ons inside that backer flow. When the
    // same browser opens the new-customer flow, do not inherit the previous
    // backer's session selection.
    const canRestoreSavedSelection = false;
    if (backerConfiguration?.rewardQuantity) {
      currentRewardQuantity = Math.max(1, Math.min(20, Number(backerConfiguration.rewardQuantity) || 1));
    } else if (canRestoreSavedSelection && savedSelection?.reward?.quantity) {
      currentRewardQuantity = Math.max(1, Math.min(20, Number(savedSelection.reward.quantity) || 1));
    }
    const requestedInput = rewardInputs.find((input) =>
      input.value === requestedReward
      || (canRestoreSavedSelection && !requestedReward && input.value === savedSelection?.reward?.id)
    );
    if (requestedInput) {
      requestedInput.checked = true;
      const requestedQuantityInput = rewardQuantityInput(requestedInput);
      if (requestedQuantityInput) requestedQuantityInput.value = String(currentRewardQuantity);
      root.querySelectorAll('[data-reward-card]').forEach((card) => card.classList.toggle('is-selected', card.contains(requestedInput)));
      nextToAddons.disabled = false;
      stepButtons.slice(1).forEach((button) => button.setAttribute('aria-disabled', 'false'));
    }
    const restoredAddonItems = requestedAddonItems.length
      ? requestedAddonItems
      : canRestoreSavedSelection
        ? (savedSelection?.addons || []).map((addon) => ({
            id: String(addon.id),
            quantity: Number(addon.quantity) || 1
          }))
        : [];
    addonInputs.forEach((input) => {
      const restoredItem = restoredAddonItems.find((item) => String(item.id) === input.value);
      input.checked = Boolean(restoredItem);
      const quantityInput = addonQuantityInput(input);
      if (quantityInput) {
        quantityInput.value = restoredItem ? String(restoredItem.quantity || 1) : '0';
        quantityInput.disabled = input.disabled;
      }
    });

    if (accessoriesOnly) {
      nextToAddons.disabled = false;
      stepButtons.slice(1).forEach((button) => button.setAttribute('aria-disabled', 'false'));
    }
    renderSummary();
    if (accessoriesOnly || (requestedInput && requestedReward && (requestedStep === 'addons' || backerConfiguration))) showStep(2);

    if (checkoutButton) {
      checkoutButton.addEventListener('click', async () => {
        const selection = selectionData() || loadSelection();
        const hasReward = Boolean(selection?.reward?.id);
        const hasAddons = Boolean(selection?.addons?.length);
        if (!hasReward && !hasAddons) {
          if (checkoutError) {
            checkoutError.hidden = false;
            checkoutError.textContent = accessoriesOnly
              ? 'Please select at least one accessory before checkout.'
              : 'Please select a machine or choose accessories only.';
          }
          return;
        }
        checkoutButton.disabled = true;
        checkoutButton.textContent = 'Preparing secure checkout…';
        if (checkoutError) checkoutError.hidden = true;
        const kickstarterSequence = /^\d{1,6}$/.test(selection.kickstarterSequence || '')
          ? selection.kickstarterSequence
          : '';
        const selectedItems = [selection.reward, ...(selection.addons || [])].filter(Boolean);
        const permalinkQuantities = new Map();
        selectedItems.forEach((item, index) => {
          const id = canonicalVariantId(item.id);
          const quantity = index === 0
            ? Math.max(1, Math.min(20, Number(item.quantity) || 1))
            : Math.max(1, Math.min(20, Number(item.quantity) || 1));
          permalinkQuantities.set(id, (permalinkQuantities.get(id) || 0) + quantity);
        });
        const openNativeCheckout = () => {
          const cartPath = [...permalinkQuantities.entries()]
            .map(([id, quantity]) => `${id}:${quantity}`)
            .join(',');
          const cartParams = new URLSearchParams();
          cartParams.set(
            'attributes[AntBelt Continuation Source]',
            kickstarterSequence ? 'Kickstarter backer continuation' : selection.accessoriesOnly ? 'Accessories-only order' : 'New campaign selection'
          );
          if (kickstarterSequence) {
            cartParams.set('attributes[Kickstarter Backer Sequence]', kickstarterSequence);
          }
          window.location.assign(`/cart/${cartPath}?${cartParams.toString()}`);
        };
        try {
          // A previously-created Shopify checkout can retain an obsolete stock
          // decision even after the campaign selection changes. Start each
          // pledge checkout from a genuinely empty cart so a stale checkout
          // cannot make an in-stock G1 appear sold out in another market.
          const clearResponse = await fetch('/cart/clear.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              attributes: {
                'Kickstarter Backer Sequence': kickstarterSequence,
                'AntBelt Continuation Source': kickstarterSequence ? 'Kickstarter backer continuation' : 'New campaign selection'
              }
            })
          });
          if (!clearResponse.ok) throw new Error('Unable to clear stale cart');

          const items = selectedItems.map((item, index) => ({
            id: Number(canonicalVariantId(item.id)),
            quantity: Math.max(1, Math.min(20, Number(item.quantity) || 1)),
            properties: {
              ...(index === 0 && kickstarterSequence
                ? { '_Kickstarter Backer Sequence': kickstarterSequence }
                : {}),
              '_AntBelt selection type':
                index === 0
                  ? 'Primary reward'
                  : item.kind === 'machine'
                    ? 'Additional machine'
                    : 'Optional add-on'
            }
          }));
          const addResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!addResponse.ok) throw new Error('Unable to add pledge selections');
          window.location.assign('/checkout');
        } catch (_) {
          checkoutButton.textContent = 'Opening secure checkout…';
          openNativeCheckout();
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["antbelt-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-hero-media]').forEach((media) => {
      const playButton = media.querySelector('[data-hero-play]');
      const video = media.querySelector('video');
      if (!playButton || !video) return;

      playButton.addEventListener('click', () => {
        playButton.hidden = true;
        video.play().catch(() => {
          playButton.hidden = false;
        });
      });
    });

    const root = document.querySelector('[data-backer-lookup]');
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const metricsUrl = root.dataset.campaignMetrics;
    if (metricsUrl) {
      fetch(metricsUrl, { headers: { Accept: 'application/json' } })
        .then((response) => {
          if (!response.ok) throw new Error(`Campaign metrics returned ${response.status}`);
          return response.json();
        })
        .then((metrics) => {
          const hasVerifiedTotals =
            ['current', 'stale'].includes(metrics?.status) &&
            typeof metrics?.total?.amountCents === 'number' &&
            Number.isFinite(metrics.total.amountCents) &&
            typeof metrics?.total?.supporters === 'number' &&
            Number.isFinite(metrics.total.supporters);
          if (!hasVerifiedTotals) {
            return;
          }
          const amount = root.querySelector('[data-campaign-pledged]');
          const supporters = root.querySelector('[data-campaign-supporters]');
          const label = root.querySelector('[data-campaign-label]');
          if (amount) {
            amount.textContent = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: metrics.currency || 'USD',
              maximumFractionDigits: 0
            }).format(metrics.total.amountCents / 100);
          }
          if (supporters) {
            supporters.textContent = new Intl.NumberFormat('en-US').format(
              metrics.total.supporters
            );
          }
          if (label && metrics?.label) label.textContent = metrics.label;

        })
        .catch(() => {});
    }

    const form = root.querySelector('[data-backer-form]');
    const input = form?.elements?.ks_sequence;
    const submit = root.querySelector('[data-backer-submit]');
    const result = root.querySelector('[data-backer-result]');
    const pledgeUrl = root.dataset.pledgeUrl;
    const accountUrl = root.dataset.accountUrl || '/account';
    const backerGroups = [
      { reward: '52562534465668', addons: [], sequences: [5,6,11,17,22,25,35,40,41,48,56,61,65,66,75,77,99,107,114,115,116,128,132,143,151,155,163,169,171,176,180,184,198,200,201,203,208,215,217,220,225,231,239,249,252,259,262,270,272,273] },
      { reward: '52562534465668', addons: ['52562534760580','52562534989956'], sequences: [80,85,86,89,93,95,113,119,122,148,149,162,178,222,224,234,245,258] },
      { reward: '52562534400132', addons: [], sequences: [1,13,15,30,54,63,68,121,152,157,183,211,227,229,240,248] },
      { reward: '52562534432900', addons: [], sequences: [7,27,88,98,117,126,133,154,159,219,221,246,263,265,269] },
      { reward: '52562534465668', addons: ['52562534760580'], sequences: [64,72,92,106,125,156,160,165,187,196,197,216,241,257] },
      { reward: '52562534465668', addons: ['52562534989956'], sequences: [71,100,103,104,140,141,150,161,181,205,226,271] },
      { reward: '52562534465668', addons: ['52562534760580','52562534727812','52562534629508','52562534989956'], sequences: [76,188,210,214,238,244] },
      { reward: '52562534465668', addons: ['52562534760580','52562534727812','52562534989956'], sequences: [112,138,190,206,254] },
      { reward: '52562534465668', addons: ['52562534727812','52562534989956'], sequences: [118,193,204,261] },
      { reward: '52562534465668', addons: ['52562534727812'], sequences: [62,123,247] },
      { reward: '52562534465668', addons: ['52562534858884'], sequences: [90,96,139] },
      { reward: '52562534465668', addons: ['52562534760580','52562534629508','52562534989956'], sequences: [147,182,267] },
      { reward: '52562534432900', addons: ['52562534989956'], sequences: [235,236,260] },
      { reward: '52562534432900', addons: ['52562534760580'], sequences: [79,87] },
      { reward: '52562534465668', addons: ['52562534760580','52562534629508'], sequences: [82,264] },
      { reward: '52562534432900', addons: ['52562534760580','52562534989956'], sequences: [97,168] },
      { reward: '52562534400132', addons: ['52562534989956'], sequences: [167,202] },
      { reward: '52562534465668', addons: ['52562534760580','52562534858884'], sequences: [173,268] },
      { reward: '52562534465668', addons: ['52562534629508'], sequences: [228,266] },
      { reward: '52562534465668', addons: ['52562534957188','52562534727812','52562534989956'], sequences: [70] },
      { reward: '52562534432900', addons: ['52562534760580','52562534891652','52562534989956'], sequences: [73] },
      { reward: '52562534465668', addons: ['52562534858884','52562534924420','52562534989956'], sequences: [74] },
      { reward: '52562534465668', addons: ['52562534760580','52562534727812','52562534989956','52562535022724'], sequences: [83] },
      { reward: '52562534432900', addons: ['52562534760580','52562534891652','52562534629508','52562534989956'], sequences: [84] },
      { reward: '52562534465668', addons: ['52562534760580','52562534858884','52562534891652','52562534924420','52562534727812'], sequences: [91] },
      { reward: '52562534465668', addons: ['52562534891652','52562534727812','52562534989956'], sequences: [94] },
      { reward: '52562534465668', addons: ['52562534760580','52562534891652','52562534629508','52562534989956'], sequences: [108] },
      { reward: '52562534465668', addons: ['52562534727812','52562535022724'], sequences: [120] },
      { reward: '52562534465668', addons: ['52562534760580','52562534957188','52562534727812'], sequences: [130] },
      { reward: '52562534400132', addons: ['52562534629508'], sequences: [131] },
      { reward: '52562534465668', addons: ['52562534760580','52562534858884','52562535022724'], sequences: [134] },
      { reward: '52562534465668', addons: ['52562534891652'], sequences: [136] },
      { reward: '52562534400132', addons: ['52562534727812'], sequences: [137] },
      { reward: '52562534432900', addons: ['52562534760580','52562534727812','52562534989956'], sequences: [142] },
      { reward: '52562534465668', addons: ['52562534760580','52562534891652','52562534727812','52562534629508','52562534989956'], sequences: [145] },
      { reward: '52562534465668', addons: ['52562534891652','52562534727812'], sequences: [146] },
      { reward: '52562534465668', addons: ['52562534760580','52562534891652','52562534989956'], sequences: [153] },
      { reward: '52562534465668', addons: ['52562534891652','52562534629508','52562534989956'], sequences: [158] },
      { reward: '52562534400132', addons: ['52562534957188'], sequences: [166] },
      { reward: '52562534465668', addons: ['52562534760580','52562534858884','52562534727812','52562534629508','52562534989956','52562535022724'], sequences: [170] },
      { reward: '52562534400132', addons: ['52562534760580','52562534989956'], sequences: [172] },
      { reward: '52562534465668', addons: ['52562534727812','52562534629508','52562534989956'], sequences: [177] },
      { reward: '52562534465668', addons: ['52562534858884','52562534891652','52562534727812','52562534629508'], sequences: [185] },
      { reward: '52562534465668', addons: ['52562534760580','52562534891652','52562534727812','52562534989956'], sequences: [186] },
      { reward: '52562534432900', addons: ['52562534858884','52562534727812','52562534989956','52562535022724'], sequences: [189] },
      { reward: '52562534465668', addons: ['52562534760580','52562534858884','52562534727812','52562534989956'], sequences: [192] },
      { reward: '52562534465668', addons: ['52562534891652','52562534727812','52562534629508'], sequences: [194] },
      { reward: '52562534432900', addons: ['52562534760580','52562534629508'], sequences: [195] },
      { reward: '52562534400132', addons: ['52562534727812','52562534989956'], sequences: [199] },
      { reward: '52562534465668', addons: ['52562534760580','52562534727812'], sequences: [207] },
      { reward: '52562534465668', addons: ['52562534891652','52562534989956'], sequences: [212] },
      { reward: '52562534465668', addons: ['52562534858884','52562534957188','52562534989956'], sequences: [213] },
      { reward: '52562534465668', addons: ['52562534760580','52562534858884','52562534924420','52562534727812','52562535022724'], sequences: [218] },
      { reward: '52562534400132', addons: ['52562534760580','52562534858884','52562534629508','52562534989956'], sequences: [232] },
      { reward: '52562534465668', addons: ['52562534727812','52562534629508'], sequences: [233] },
      { reward: '52562534465668', addons: ['52562534760580','52562534891652','52562534924420','52562534727812','52562534629508','52562534989956','52562535022724'], sequences: [237] },
      { reward: '52562534465668', addons: ['52562534727812','52562534989956','52562535022724'], sequences: [242] },
      { reward: '52562534400132', addons: ['52562534727812','52562534629508'], sequences: [243] },
      { reward: '52562534465668', addons: ['52562534858884','52562534989956'], sequences: [250] },
      { reward: '52562534465668', addons: ['52562534760580','52562534858884','52562534629508','52562534989956'], sequences: [251] },
      { reward: '52562534400132', addons: ['52562534727812','52562534989956','52562535022724'], sequences: [253] },
      { reward: '52562534465668', addons: ['52562534760580','52562534858884','52562534891652','52562534924420','52562534727812','52562534629508','52562534989956','52562535022724'], sequences: [255] },
      { reward: '52562534465668', addons: ['52562534760580','52562534858884','52562534957188','52562534727812','52562534629508','52562534989956','52562535022724'], sequences: [256] },
      { reward: '52562534465668', addons: ['52562534760580','52562534858884','52562534629508','52562534989956','52562535022724'], sequences: [274] }
    ];
    const genericBackers = [3,4,8,12,14,16,18,19,20,21,23,26,28,31,32,33,34,36,37,38,39,42,43,44,46,47,49,50,52,53,55,57,58,59,60,105,124,164,223];

    const showResult = ({ title, message, actionLabel, actionUrl, className = '' }) => {
      result.className = `ab-backer-result ${className}`.trim();
      result.innerHTML = '';
      const heading = document.createElement('h3');
      heading.textContent = title;
      const copy = document.createElement('p');
      copy.textContent = message;
      result.append(heading, copy);
      if (actionLabel && actionUrl) {
        const action = document.createElement('a');
        action.className = 'button button-primary';
        action.href = actionUrl;
        action.textContent = actionLabel;
        result.appendChild(action);
      }
      result.hidden = false;
    };

    form?.addEventListener('submit', (event) => {
      event.preventDefault();
      const sequence = String(input?.value || '').replace(/\D/g, '').slice(0, 6);
      input.value = sequence;
      if (!sequence) {
        showResult({
          title: 'Enter your backer number',
          message: 'Use the numeric sequence from your Kickstarter pledge record.',
          className: 'is-warning'
        });
        return;
      }

      const numericSequence = Number(sequence);
      const configuration = backerGroups.find((group) => group.sequences.includes(numericSequence));
      if (configuration) {
        const nextUrl = new URL(pledgeUrl, window.location.origin);
        nextUrl.searchParams.set('ks_sequence', sequence);
        nextUrl.searchParams.set('reward', configuration.reward);
        if (configuration.addons.length) nextUrl.searchParams.set('addons', configuration.addons.join(','));
        if (submit) {
          submit.disabled = true;
          submit.textContent = 'Opening…';
        }
        window.location.assign(nextUrl.toString());
        return;
      }

      if (genericBackers.includes(numericSequence)) {
        const nextUrl = new URL(pledgeUrl, window.location.origin);
        nextUrl.searchParams.set('ks_sequence', sequence);
        if (submit) {
          submit.disabled = true;
          submit.textContent = 'Opening…';
        }
        window.location.assign(nextUrl.toString());
        return;
      }

      showResult({
        title: 'Backer number not found',
        message: 'Check the number or choose your G1 again.',
        actionLabel: 'View my orders',
        actionUrl: accountUrl,
        className: 'is-warning'
      });
    });

    const requestedSequence = new URLSearchParams(window.location.search).get('ks_sequence');
    if (requestedSequence && form && input) {
      input.value = requestedSequence.replace(/\D/g, '').slice(0, 6);
      form.requestSubmit();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["antbelt-kickstarter-archive"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('.ks-archive').forEach((archive) => {
    if (archive.dataset.ready === 'true') return;
    archive.dataset.ready = 'true';

    const search = archive.querySelector('[data-archive-search]');
    const empty = archive.querySelector('[data-archive-empty]');
    const more = archive.querySelector('[data-comments-more]');
    const items = [...archive.querySelectorAll('[data-search]')];
    const replyForm = archive.querySelector('.ks-live-comments__form');
    const replyBody = replyForm?.querySelector('[data-comment-body]');

    archive.querySelectorAll('.ks-archive-comment').forEach((comment) => {
      const meta = comment.querySelector('.ks-archive-comment__meta');
      const author = meta?.querySelector('strong')?.textContent.trim();
      if (!meta || !author || meta.querySelector('[data-comment-reply]')) return;
      const reply = document.createElement('button');
      reply.type = 'button';
      reply.className = 'ks-comment-reply';
      reply.dataset.commentReply = author;
      reply.textContent = 'Reply';
      meta.append(reply);
    });

    archive.addEventListener('click', (event) => {
      const reply = event.target.closest('[data-comment-reply]');
      if (!reply || !replyBody || !replyForm) return;
      const mention = `@${reply.dataset.commentReply} `;
      if (!replyBody.value.startsWith(mention)) replyBody.value = `${mention}${replyBody.value}`;
      replyForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
      replyBody.focus({ preventScroll: true });
    });

    const filterItems = () => {
      const query = (search?.value || '').trim().toLowerCase();
      let visible = 0;
      items.forEach((item) => {
        const matches = !query || (item.dataset.search || '').includes(query);
        item.hidden = !matches;
        if (matches) {
          item.classList.remove('is-collapsed');
          visible += 1;
        }
      });
      if (!query) {
        items.forEach((item, index) => {
          if (item.classList.contains('ks-archive-thread')) item.classList.toggle('is-collapsed', index >= 8);
        });
      }
      if (empty) empty.hidden = visible !== 0;
      if (more) more.hidden = Boolean(query) || !items.some((item) => item.classList.contains('is-collapsed'));
    };

    search?.addEventListener('input', filterItems);
    more?.addEventListener('click', () => {
      archive.querySelectorAll('.ks-archive-thread.is-collapsed').forEach((item, index) => {
        if (index < 8) item.classList.remove('is-collapsed');
      });
      more.hidden = !archive.querySelector('.ks-archive-thread.is-collapsed');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["antbelt-kickstarter-story-exact"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-campaign-metrics]').forEach((summary) => {
    const metricsUrl = summary.dataset.campaignMetrics;
    if (!metricsUrl || summary.dataset.metricsReady === 'true') return;
    summary.dataset.metricsReady = 'true';

    fetch(metricsUrl, { headers: { Accept: 'application/json' } })
      .then((response) => {
        if (!response.ok) throw new Error(`Campaign metrics returned ${response.status}`);
        return response.json();
      })
      .then((metrics) => {
        const hasVerifiedTotals =
          ['current', 'stale'].includes(metrics?.status) &&
          typeof metrics?.total?.amountCents === 'number' &&
          Number.isFinite(metrics.total.amountCents) &&
          typeof metrics?.total?.supporters === 'number' &&
          Number.isFinite(metrics.total.supporters);
        if (!hasVerifiedTotals) {
          return;
        }
        const amount = summary.querySelector('[data-campaign-pledged]');
        const supporters = summary.querySelector('[data-campaign-supporters]');
        const label = summary.querySelector('[data-campaign-label]');
        if (amount) {
          amount.textContent = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: metrics.currency || 'USD',
            maximumFractionDigits: 0
          }).format(metrics.total.amountCents / 100);
        }
        if (supporters) {
          supporters.textContent = new Intl.NumberFormat('en-US').format(
            metrics.total.supporters
          );
        }
        // Keep the funding label explicitly historical on the preorder page.

      })
      .catch(() => {});
  });

  document.querySelectorAll('[data-hero-media]').forEach((media) => {
    const playButton = media.querySelector('[data-hero-play]');
    const video = media.querySelector('video');
    if (!playButton || !video) return;

    playButton.addEventListener('click', () => {
      playButton.hidden = true;
      video.play().catch(() => {
        playButton.hidden = false;
      });
    });
  });

  const slugify = (value) => value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');

  document.querySelectorAll('[data-reward-purchase]').forEach((purchase) => {
    if (purchase.dataset.quantityReady === 'true') return;
    purchase.dataset.quantityReady = 'true';

    const minus = purchase.querySelector('[data-reward-minus]');
    const plus = purchase.querySelector('[data-reward-plus]');
    const output = purchase.querySelector('[data-reward-quantity]');
    const link = purchase.querySelector('[data-reward-link]');
    if (!minus || !plus || !output || !link) return;

    let quantity = 1;
    const setQuantity = (nextQuantity) => {
      quantity = Math.max(1, Math.min(20, Math.round(Number(nextQuantity) || 1)));
      output.textContent = String(quantity);
      minus.disabled = quantity <= 1;
      plus.disabled = quantity >= 20;
      const url = new URL(link.href, window.location.origin);
      url.searchParams.set('quantity', String(quantity));
      link.href = url.pathname + url.search;
    };

    minus.addEventListener('click', () => setQuantity(quantity - 1));
    plus.addEventListener('click', () => setQuantity(quantity + 1));
    setQuantity(1);
  });

  document.querySelectorAll('.ks-story-exact').forEach((section) => {
    if (section.dataset.tocReady === 'true') return;
    section.dataset.tocReady = 'true';

    const toc = section.querySelector('.ks-story-exact__toc');
    const nav = section.querySelector('.ks-story-exact__toc-links');
    const mobilePledge = section.querySelector('[data-mobile-pledge]');
    const rewards = section.querySelector('#available-rewards');
    if (mobilePledge && rewards && 'IntersectionObserver' in window) {
      const rewardObserver = new IntersectionObserver(([entry]) => {
        mobilePledge.classList.toggle('is-hidden', entry.isIntersecting);
      }, { threshold: 0.05 });
      rewardObserver.observe(rewards);
    }
    const allHeadings = [...section.querySelectorAll('.ks-story-exact__content h3')];
    allHeadings.forEach((heading, index) => {
      heading.id = `story-${slugify(heading.textContent) || 'section'}-${index + 1}`;
    });
    const featuredChapters = [
      'AntBelt G1: Real Galvo Power, Starting From US$99',
      'See The Machine Work Before You Order',
      'The Big Difference: 80 x 80mm Daily Jobs, 80 x 2000mm Long Projects',
      'AntBelt Studio: Software Is Part Of The Product',
      'Rotary Roller And Chuck Options For More Products',
      'Accessories & Add-Ons, That Expand Your Workflow',
      'Key Features At A Glance',
      "What's In The Box",
      'Production And QC Plan',
      'Shipping And Fulfillment',
      'FAQ',
      'Meet The Team Building The Tool'
    ];
    const headings = allHeadings.filter((heading) => featuredChapters.includes(heading.textContent.trim()));
    const links = headings.map((heading, index) => {
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      nav.appendChild(link);
      return link;
    });

    let ticking = false;
    const setActiveChapter = () => {
      const currentIndex = headings.reduce((activeIndex, heading, index) => (
        heading.getBoundingClientRect().top <= 160 ? index : activeIndex
      ), 0);
      links.forEach((link) => link.removeAttribute('aria-current'));
      const active = links[currentIndex];
      if (active) {
        active.setAttribute('aria-current', 'true');
        const navRect = toc.getBoundingClientRect();
        const activeRect = active.getBoundingClientRect();
        if (activeRect.top < navRect.top) toc.scrollTop -= navRect.top - activeRect.top + 8;
        if (activeRect.bottom > navRect.bottom) toc.scrollTop += activeRect.bottom - navRect.bottom + 8;
      }
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(setActiveChapter);
    }, { passive: true });
    setActiveChapter();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["campaign-workshop-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-campaign-add]');
    if (!button) return;
    const id = button.dataset.variantId;
    if (!id) return;
    button.disabled = true;
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id, quantity: 1 }] }) });
      if (!response.ok) throw new Error('cart add failed');
      window.location.assign('/cart');
    } catch (error) {
      button.disabled = false;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
